export const brokerRegex = /<BROKER>/gi;
export const distributorRegex = /<DISTRIBUTOR>/gi;
export const smallcaseRegex = /<SMALLCASE>/gi;
export const orderDetailsRegex = /<ORDER_DETAILS>/gi;



// WEBPACK FOOTER //
// ./utils/copyConstants.js